import { timestamp, filter, map, takeWhile, take, publishReplay, refCount } from 'rxjs/operators';
import { schedulerNow } from '../utils/now';
export var CacheMode;
(function (CacheMode) {
    CacheMode[CacheMode["Default"] = 0] = "Default";
    CacheMode[CacheMode["TolerateExpired"] = 1] = "TolerateExpired";
    CacheMode[CacheMode["SilentRefresh"] = 2] = "SilentRefresh";
})(CacheMode || (CacheMode = {}));
export function cache(windowTime, mode, scheduler) {
    if (mode === void 0) { mode = CacheMode.Default; }
    return function (source) {
        if (mode === CacheMode.SilentRefresh) {
            return source.pipe(timestamp(scheduler), publishReplay(1, Number.POSITIVE_INFINITY, scheduler), refCount(), takeWhile(function (item, i) {
                if (i === 0) {
                    return schedulerNow(scheduler) > item.timestamp + windowTime;
                }
                return false;
            }, true), filter(function (_, i) { return i === 0; }), map(function (item) { return item.value; }));
        }
        else if (mode === CacheMode.TolerateExpired) {
            return source.pipe(timestamp(scheduler), publishReplay(1, Number.POSITIVE_INFINITY, scheduler), refCount(), takeWhile(function (item) { return schedulerNow(scheduler) > item.timestamp + windowTime; }, true), map(function (item) { return item.value; }));
        }
        else {
            return source.pipe(publishReplay(1, windowTime, scheduler), refCount(), take(1));
        }
    };
}
//# sourceMappingURL=cache.js.map